export class Block{
    public constructor(
        public id:String = "",
        public secuencial_inicio:String = "",
        public secuencial_fin:String = "",
        public fecha_emision:String = "",
        public fecha_caducidad:String = "",
        public numero_autorizacion: String = "",
        public comprobante_id:String = "",
        public status:String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public usuario_id:String = null
    ){ }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/block.ts